export type TraderType = 'scalper' | 'intraday' | 'swing';

export interface TraderTypeOption {
    value: TraderType;
    label: string;
    color: string;
}

export const TRADER_TYPE_OPTIONS: TraderTypeOption[] = [
    {
        value: 'scalper',
        label: 'Scalper',
        color: '#52c41a', // Green
    },
    {
        value: 'intraday',
        label: 'Intraday Trader',
        color: '#1F4ECD', // Primary blue
    },
    {
        value: 'swing',
        label: 'Swing Trader',
        color: '#722ed1', // Purple
    },
];

export const DEFAULT_TRADER_TYPE: TraderType = 'intraday';
